// Not Found (legacy pages/ErrorNotFound.vue in AlternateLayout, SCR-167): where every unknown URL lands, including the
// 14 pages of legacy's shadowed settings tree (routes.md §7.13). Measured on local legacy at 1280×800 (D6 round 32): the
// Radish logo 200×50 with 32 px below it, "404 - Not Found" in primary green on a 50 px line, Go back as a flat white
// 200×36 button, and the 50 px burgundy footer with legacy's three links. Legacy also reserves a blank 150 px box for
// `/logo-blue-icon.svg`, a file it no longer ships; that box is left out (bug B378, ledger L534). Go back is `color="white"`,
// white in dark too, its label primary (#b4d5ac in dark; B2028). Under the pointer Quasar's focus helper lays the label
// colour at 15 % over that white, so the button stays pale in both themes.
import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { AuthLayout } from '@radish/ui-web';

export function NotFoundPage() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = '404 - Page Not Found';
  }, []);
  // Legacy's goHome: the location's dashboard, else Accounts, else Log in. `/` makes the same choice (Home and its guard).
  const goBack = () => void navigate({ to: '/' });
  return (
    <AuthLayout logoSrc="/radish-logo.svg" darkLogoSrc="/radish-logo-dark.svg">
      <div className="w-[200px] text-center" data-testid="not-found-page">
        <h3 className="text-[14px] leading-[50px] text-primary" data-testid="not-found-message">
          <strong>404</strong> - Not Found
        </h3>
        <button
          type="button"
          onClick={goBack}
          className="h-9 w-[200px] rounded-[8px] bg-white text-[14px] text-primary transition-colors hover:bg-[color-mix(in_srgb,var(--color-primary)_15%,white)]"
        >
          Go back
        </button>
      </div>
    </AuthLayout>
  );
}
